import { t } from 'i18next';
import * as yup from 'yup';

import { createPasswordInputSchema } from 'core/components/form';

export const changePasswordSchema = yup
  .object({
    oldPassword: createPasswordInputSchema({
      name: t('pages.settings.changePasswordForm.fields.oldPassword.name'),
    }),
    newPassword: createPasswordInputSchema({
      name: t('pages.settings.changePasswordForm.fields.newPassword.name'),
    }),
    confirmNewPassword: createPasswordInputSchema({
      name: t(
        'pages.settings.changePasswordForm.fields.confirmNewPassword.name'
      ),
    }).oneOf([yup.ref('newPassword')], t('errors.validation.password.match')),
  })
  .required();

export type ChangePasswordFormData = yup.InferType<typeof changePasswordSchema>;
